import React from 'react';

import { TableCell, TableHead, TableRow, TableSortLabel, Checkbox } from '@material-ui/core';

const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Location Name' },
  { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
  { id: 'address', numeric: false, disablePadding: false, label: 'Address' },
  { id: 'edit', numeric: false, disablePadding: false, label: ' ' },
];

export const LocationsTableHead = (props) => {
  const { classes, order, orderBy, onRequestSort, numSelected, rowCount, onSelectAllClick } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            className={classes.checked}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
